import React from "react";

function test() {
  return (
    // <div className="border-2 border-white h-full w-full justify-center flex flex-col">
    <div className="flexbox-container">
      <h1> Hello World </h1>
      <p>I love second savour</p>
    </div>
  );
}

export default test;
